import {dangerColor, grayColor, successColor, warningColor} from './assets/js/nextjs-material-dashboard';
import {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import {LinearProgress, Typography} from '@mui/material';

export const primaryColor = ['#062f4f', '#192231', '#007dc1', '#192231'];

export const BASE_URL = 'https://00h30mwnvi.execute-api.eu-central-1.amazonaws.com/dev';

export const PORT_GDYNIA_MAIN_COLOR = 'rgb(43,53,130)';


export const ThresholdByMeasurement = {
  'chlorophyll': 400,
  'PM10': 110,
  'PM25': 75,
  'noise': 90,
  'oil': 100,
  'ph': 14,
  'ec': 1000,
  'orp': 300,
  'turbidity': 2000,
  'no3': 50,
  'o2': 100,

  'airTemp': 40,
  'humidity': 100,
  'soilHumidity': 100,
  'soilTemp': 20,
  'soilSurfTemp': 35,
  'leafTemp': 30,
  'leafWetnessYMSD': 100,

  'lightVisible': 100,
  'windSpeedMax': 20
};


export const colorByPm10 = (pm10, pm100) => {
  if (pm100) {
    return primaryColor[2];
  }

  if (pm10 < 0) {
    return grayColor[0];
  }
  if (pm10 < 20) {
    return successColor[2];
  } else if (pm10 < 50) {
    return successColor[0];
  } else if (pm10 < 80) {
    return '#FFD911';
  } else if (pm10 < 110) {
    return warningColor[0];
  } else {
    return dangerColor[0];
  }
};

export const colorByPm25 = pm25 => {
  if (pm25 < 0) {
    return grayColor[0];
  }
  if (pm25 < 13) {
    return successColor[2];
  } else if (pm25 < 35) {
    return successColor[0];
  } else if (pm25 < 55) {
    return '#FFD911';
  } else if (pm25 < 75) {
    return warningColor[0];
  } else {
    return dangerColor[0];
  }
};

export const colorByNoise = noiseLvl => {
  if (noiseLvl <= 0) {
    return grayColor[0];
  }
  if (noiseLvl < 40) {
    return successColor[2];
  } else if (noiseLvl < 55) {
    return successColor[0];
  } else if (noiseLvl < 65) {
    return '#FFD911';
  } else if (noiseLvl < 85) {
    return warningColor[0];
  } else {
    return dangerColor[0];
  }
};
export const colorsByMeasurements = {
  'PM10': colorByPm10,
  'PM25': colorByPm25,
  'PM1': colorByPm25,
  'noise': colorByNoise,
};
function CustomLinearProgress({value, min, max, color, hidePercentage}) {
  const [interValue, setInterValue] = useState(min);
  const [inter, setInt] = useState(min);

  useEffect(() => {
    const interval = setInterval(() => {
      const stepValue = value / 20;
      setInterValue((prevValue) => prevValue + stepValue);
    }, 10);
    setInt(interval);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (interValue > value) {
      clearInterval(inter);
    }
  }, [interValue, inter]);

  return (
    <Box mt={hidePercentage ? 2 : 0} sx={{display: 'flex', alignItems: 'center'}}>
      <Box sx={{width: hidePercentage ? '85%' : '100%', mr: 1, color: color || 'darkgray'}}>
        <LinearProgress color="inherit" value={Math.max(0, Math.min(100, (interValue / max) * 100))}
                        variant="determinate" min={min} max={max}/>
      </Box>
      {!hidePercentage && <Box sx={{minWidth: 35}}>
        <Typography variant="body2" sx={{color: '#D3D3D3'}}>{`${Math.round((interValue / max) * 100)}%`}</Typography>
      </Box>}
    </Box>
  );
}

export const ValueSlider = ({measurementType: m, value}) => {
  return <CustomLinearProgress hidePercentage={['soilTemp', 'airTemp', 'soilSurfTemp', 'ph', 'o2'].includes(m)} value={value} min={0}
                               max={ThresholdByMeasurement[m]} color={colorsByMeasurements[m](value)}/>;
};
